import { render, staticRenderFns } from "./comboAssetsDetail.vue?vue&type=template&id=ee7ae024&scoped=true"
import script from "./comboAssetsDetail.vue?vue&type=script&lang=js"
export * from "./comboAssetsDetail.vue?vue&type=script&lang=js"
import style0 from "./comboAssetsDetail.vue?vue&type=style&index=0&id=ee7ae024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7ae024",
  null
  
)

export default component.exports